/** @flow */
import { spawn } from "redux-saga/effects";
import overviewSaga from "./overview";
import reportSaga from "./report";

export default function* focusListSaga(): Generator<*, void, void> {
  yield spawn(overviewSaga);
  yield spawn(reportSaga);
}
